<script setup>
import { objectOmit } from '@vueuse/core'
import { onlyAllowNumber } from '@/utils/tools'

const props = defineProps({
  isButton: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['handleOpt'])

const errorMsg = defineModel('error', { default: '' })
const input = ref()

function handleClickButton(val) {
  if (props.disabled)
    return
  emit('handleOpt', val)
}

defineExpose({
  nInput: input,
})
</script>

<template>
  <div>
    <n-input
      ref="input" style="--n-suffix-text-color: var(--textTextSecondary); --n-font-size: 12px;" :placeholder="$t('请输入')" :allow-input="(value) => onlyAllowNumber(value)"
      :status="errorMsg ? 'error' : undefined" class="font-medium text-end !transition-none" v-bind="objectOmit($attrs, ['class'])" :disabled="disabled"
    >
      <template #prefix>
        <slot name="prefix" />
      </template>
      <template #suffix>
        <slot name="suffix">
          <div class="flex h-full ps-1 -me-3">
            <slot name="suffix-extra" />
            <div v-if="isButton" class="flex flex-col h-full border-s cursor-pointer w-7 border-border">
              <div
                :class="{ 'cursor-not-allowed': disabled }"
                class="flex items-center flex-1 ps-2 border-b border-border"
                @click="handleClickButton(1)"
              >
                <svg width="12" height="12" class="w-2.5 h-2.5" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd" clip-rule="evenodd"
                    d="M6.5 0.5C6.5 0.223858 6.27614 0 6 0C5.72386 0 5.5 0.223858 5.5 0.5V5.5H0.5C0.223858 5.5 0 5.72386 0 6C0 6.27614 0.223858 6.5 0.5 6.5H5.5V11.5C5.5 11.7761 5.72386 12 6 12C6.27614 12 6.5 11.7761 6.5 11.5V6.5H11.5C11.7761 6.5 12 6.27614 12 6C12 5.72386 11.7761 5.5 11.5 5.5H6.5V0.5Z"
                    fill="#868686"
                  />
                </svg>
              </div>
              <div
                :class="{ 'cursor-not-allowed': disabled }"
                class="flex items-center flex-1 ps-2" @click="handleClickButton(-1)"
              >
                <svg width="12" height="2" class="w-2.5" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="0.5" width="12" height="1" rx="0.5" fill="#868686" />
                </svg>
              </div>
            </div>
          </div>
        </slot>
      </template>
    </n-input>
    <div v-if="errorMsg" class="mt-2 text-xs text-start error-msg text-error">
      {{ errorMsg }}
    </div>
  </div>
</template>
